'use strict'; //

exports.__esModule = true;
exports.default = void 0;

require("./upload.less");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _jquery = _interopRequireDefault(require("jquery"));

var _component = _interopRequireDefault(require("../core/component"));

var _enhance = _interopRequireDefault(require("../core/enhance"));

var _http = _interopRequireDefault(require("./http"));

var _directive = _interopRequireDefault(require("../common/directive"));

var _tools = _interopRequireDefault(require("../libs/tools"));

var _reactDom = _interopRequireDefault(require("react-dom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var showDom;
/**
 * 上传
 */

var Upload = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Upload, _Component);

  function Upload(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      uuid: _tools.default.uuid()
    };

    _this.handlerChange = function () {
      var file = _this.file.files[0];

      if (file) {
        var ext = file.name.substring(file.name.lastIndexOf(".") + 1);

        var size = _tools.default.translateScalars(_this.state.size || '1M');

        if (_this.state.filter.indexOf(ext) === -1) {
          _this.state.onError && _this.state.onError("文件类型错误", file);
          window.toast('文件类型错误');

          _this.setState({
            uuid: _tools.default.uuid()
          });

          return;
        }

        if (file.size > size) {
          _this.state.onError && _this.state.onError("文件过大", file);
          window.toast('文件过大');

          _this.setState({
            uuid: _tools.default.uuid()
          });

          return;
        }

        _this.upload();
      }
    };

    _this.upload = function () {
      var file = _this.file.files[0]; // let [type, ext] = file.type.split("/");

      var name = file.name;
      var post = _this.state.post;

      if (_tools.default.is_function(post)) {
        post = post();
      }

      var formData = new FormData();
      formData.append(_this.state.name, file, name);

      _jquery.default.each(post || {}, function (key, val) {
        formData.append(key, val);
      });

      _this.http.send(_this.state.url, formData).progress(_this.handlerProgress).success(_this.handlerSuccess).error(_this.handlerError).complete(_this.handlerComplete);
    };

    _this.handlerProgress = function (data) {
      window.uploadProgress && window.uploadProgress(data.percentComplete * 100);
      _this.state.onProgress && _this.state.onProgress(data);
    };

    _this.handlerComplete = function (data) {
      window.uploadProgress && window.uploadProgress(null);
      _this.state.onComplete && _this.state.onComplete(data);

      _this.setState({
        uuid: _tools.default.uuid()
      });
    };

    _this.handlerError = function (data) {
      _this.state.onError && _this.state.onError(data);
    };

    _this.handlerSuccess = function (data) {
      _this.state.onSuccess && _this.state.onSuccess(data);
    };

    _this.post = function (post) {
      _this.setState({
        post: post
      });
    };

    _jquery.default.extend(_this.state, _this.props);

    if (!showDom) {
      showDom = (0, _jquery.default)("<div id=\"" + _tools.default.uuid() + "\"></div>")[0];
      (0, _jquery.default)(document.body).append(showDom);
    }

    return _this;
  }
  /**
   * 输入参数 nextProps 是即将被设置的属性，
   * 旧的属性还是可以通过 this.props 来获取。
   * 在这个回调函数里面，你可以根据属性的变化，
   * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
   * 并不会触发额外的 render() 调用
   */


  var _proto = Upload.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    _jquery.default.extend(this.state, nextProps, true);
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/_react.default.createElement("label", {
      className: (0, _classnames.default)('c-upload', this.state.className),
      form: this.state.uuid,
      key: this.state.uuid
    }, this.state.children, /*#__PURE__*/_react.default.createElement(_http.default, {
      ref: function ref(_ref) {
        return _this2.http = _ref;
      }
    }), /*#__PURE__*/_react.default.createElement("input", {
      key: this.state.index,
      id: this.state.uuid,
      ref: function ref(_ref2) {
        return _this2.file = _ref2;
      },
      type: "file",
      onChange: this.handlerChange,
      style: {
        display: 'none'
      }
    }));
  }
  /**
   *
   * @return {{children, implementation, containerInfo, $$typeof, key}}
   */
  ;

  _proto.renderProgress = function renderProgress() {
    var _this3 = this;

    return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
      ref: function ref(_ref3) {
        return _this3.progress = _ref3;
      },
      className: (0, _classnames.default)("c-upload-progress")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("c-upload-progress-total")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("c-upload-progress-position")
    }))), showDom);
  }
  /**
   *
   */
  ;

  return Upload;
}(_component.default);

(0, _enhance.default)(Upload, {
  defaultProps: {
    size: '1M',
    //文件大小
    filter: ['png', 'jpg', 'jpeg'],
    //过滤文件
    post: {},
    //其他参数
    name: "image" //field

  }
}, 'Upload');
var _default = Upload;
exports.default = _default;
module.exports = exports.default;